export default __webpack_public_path__ + "static/evadim2-f78fb5c6535ab96df54762c25207a71c.png";